export default __webpack_public_path__ + "static/media/AssignmentHome.36b847a0.svg";